import React from "react";
import autoBind from "react-autobind";
import {Redirect} from "react-router-dom";
import noty from "../../../lib/noty";
import Field from "../../../components/Field";
import FieldSelect from "../../../components/FieldSelect";
import HelpText from "../../../components/HelpText";
import {pointInstructions} from "../../../strings/en-us/text";
import {InstructionsContainer} from "../../../components/Instructions";
import {PanelContainer, Panel} from "../../../components/Panel";
import {MapPortal} from "../../../components/Map";
import {MarkerPanel, withMarkerPanel, MarkerPanelMarkers} from "../../../components/MarkerPanel";
import MapEditMarker from "../MapEditMarker";

class NewMarker extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      panelOpen: true,
      fetching: false,
      touched: false,
      redirect: null,
      marker: this.props.marker
    };
  }

  handlePanelToggle() {
    this.setState({panelOpen: !this.state.panelOpen});
  }

  handleChange({name, value}) {
    const path = name.split(".");
    this.setState({
      touched: true,
      marker: this.state.marker.setIn(path, value)
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const {marker} = this.state;
    this.setState({fetching: true});
    marker
      .create()
      .then(created => {
        this.setState({redirect: `${this.props.match.url}/${created._id}`});
        noty.success("Marker Created.");
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const {marker, touched, fetching} = this.state;
    const {floor, match, markerFilter, toggleAllMarkerFilter, toggleMarkerFilter} = this.props;
    const markers = floor.markers();
    return (
      <div>
        <PanelContainer width={475} open={this.state.panelOpen} onToggle={this.handlePanelToggle}>
          <Panel
            checkCanAdd="markers"
            onSaveClick={this.handleSubmit}
            saveTitle="Create New Marker"
            fetching={fetching}
            touched={touched}
            touchedMessage="Are you sure that you want to leave? This marker has unsaved changes.">
            <div>
              <div className="row">
                <div className="col-xs-12">
                  <FieldSelect
                    name="type_id"
                    value={marker.type_id}
                    onChange={this.handleChange}
                    label="Marker Type"
                    options={marker.selectOptions()}
                    disabled={fetching}
                    tooltip="Choose the type of asset to have a relevant icon on the map"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <Field
                    name="name"
                    value={marker.name}
                    onChange={this.handleChange}
                    label="Marker Name"
                    disabled={fetching}
                    tooltip="Give the asset a descriptive name for the map"
                  />
                </div>
              </div>
              <InstructionsContainer>{pointInstructions}</InstructionsContainer>
              <HelpText
                description="Need help? See our guide on adding a marker."
                href="https://mapplug.zendesk.com/hc/en-us/articles/360006322674-Adding-a-marker-to-a-building"
              />
            </div>
          </Panel>
          <MarkerPanel
            match={match}
            floor={floor}
            toggleMarkerFilter={toggleMarkerFilter}
            toggleAllMarkerFilter={toggleAllMarkerFilter}
            markerFilter={markerFilter}
            disabled={fetching}
          />
        </PanelContainer>
        <MapPortal center={marker.geo.coordinates}>
          <MapEditMarker
            marker={marker}
            floor={floor}
            onMarkerLocationChange={coords =>
              this.handleChange({
                name: "geo.coordinates",
                value: coords
              })
            }
          />
          <MarkerPanelMarkers match={match} markers={markers} markerFilter={markerFilter} floor={floor} />
        </MapPortal>
      </div>
    );
  }
}

export default withMarkerPanel(NewMarker);



// WEBPACK FOOTER //
// ./src/pages/Facility/NewMarker/index.jsx